import AppContainer from './containers/AppContainer';

export default AppContainer;